// ════════════════════════════════════════════════════════════════════
// SPRITE MANIFEST — Mark-rollout stub
// ────────────────────────────────────────────────────────────────────
// This title has no per-gender walkable-world player sprite sheet (no
// existing CDN art under player_f_*/player_m_* keys, and no CDN.js of
// its own to host them). Rather than point PLAYER_SPRITES at another
// title's CDN -- cross-game hotlinking of art that may not even match --
// this ships empty on purpose.
//
// Mark.js's Portrait() already has a real fallback for exactly this:
//   const src = PLAYER_SPRITES[...] || PLAYER_SPRITES[...] || ...;
//   {src ? <img src={src} .../> : <div>{seal}</div>}
// With no keys present, every lookup is undefined and the Mark renders
// the player's seal glyph in place of a portrait -- not a broken image.
//
// If/when this title gets real player portrait art on its own CDN,
// populate PLAYER_SPRITES the way app-annihilation/src/SpriteManifest.js
// does (player_f_front_a, player_f_default, player_f_idle_a, and the
// _m_ equivalents) and the Mark picks it up with no other changes.
// ════════════════════════════════════════════════════════════════════

export const PLAYER_SPRITES = {};
